import { Ml_Log_Event, Ml_Log_Status } from '@generated/graphql';
import palette from 'theme/palette';
import { grey } from '@mui/material/colors';
import { GradeColor } from 'types/mui';
import { generateOptions } from 'utils/format';

export const LOG_EVENT_TITLE: {
  [key in Ml_Log_Event]: string;
} = {
  [Ml_Log_Event.AssessAnswer]: 'Ответ в оценке',
  [Ml_Log_Event.CmFromDescription]: 'Комментарий из описания',
  [Ml_Log_Event.CmFromVacancy]: 'Комментарий из вакансии',
  [Ml_Log_Event.GenerateQuestions]: 'Генерация вопросов',
  [Ml_Log_Event.GenerateReport]: 'Генерация отчета',
  [Ml_Log_Event.GenerateAltReport]: 'Генерация отчета',
  [Ml_Log_Event.Regenerate]: 'Регенерация вопроса',
  [Ml_Log_Event.RegenerateSync]: 'Регенерация вопроса синхронная',
  [Ml_Log_Event.RelevanceAssessment]: 'Оценка релевантности',
};

export const LOG_EVENT: {
  [key in Ml_Log_Event]: {
    color: GradeColor['light'];
    backgroundColor: GradeColor['contrast'];
    title: string;
  };
} = {
  [Ml_Log_Event.AssessAnswer]: {
    color: palette.orange.light,
    backgroundColor: palette.orange.contrast,
    title: LOG_EVENT_TITLE[Ml_Log_Event.AssessAnswer],
  },
  [Ml_Log_Event.CmFromDescription]: {
    color: palette.green.light,
    backgroundColor: palette.green.contrast,
    title: LOG_EVENT_TITLE[Ml_Log_Event.CmFromDescription],
  },
  [Ml_Log_Event.CmFromVacancy]: {
    color: palette.red.light,
    backgroundColor: palette.red.contrast,
    title: LOG_EVENT_TITLE[Ml_Log_Event.CmFromVacancy],
  },
  [Ml_Log_Event.GenerateQuestions]: {
    color: palette.red.light,
    backgroundColor: palette.red.contrast,
    title: LOG_EVENT_TITLE[Ml_Log_Event.GenerateQuestions],
  },
  [Ml_Log_Event.GenerateReport]: {
    color: grey[400],
    backgroundColor: grey[700],
    title: LOG_EVENT_TITLE[Ml_Log_Event.GenerateReport],
  },
  [Ml_Log_Event.GenerateAltReport]: {
    color: grey[400],
    backgroundColor: grey[700],
    title: LOG_EVENT_TITLE[Ml_Log_Event.GenerateAltReport],
  },
  [Ml_Log_Event.Regenerate]: {
    color: grey[400],
    backgroundColor: grey[700],
    title: LOG_EVENT_TITLE[Ml_Log_Event.Regenerate],
  },
  [Ml_Log_Event.RegenerateSync]: {
    color: grey[400],
    backgroundColor: grey[700],
    title: LOG_EVENT_TITLE[Ml_Log_Event.RegenerateSync],
  },
  [Ml_Log_Event.RelevanceAssessment]: {
    color: grey[400],
    backgroundColor: grey[700],
    title: LOG_EVENT_TITLE[Ml_Log_Event.RelevanceAssessment],
  },
};

export const LOG_EVENT_OPTIONS: Array<{ id: Ml_Log_Event; displayName: string }> =
  generateOptions(LOG_EVENT_TITLE);

export const LOG_STATUS_TITLE = {
  [Ml_Log_Status.Error]: 'Ошибка',
  [Ml_Log_Status.Initialized]: 'Инициализация',
  [Ml_Log_Status.InternalError]: 'Внутренняя ошибка',
  [Ml_Log_Status.RequestFailed]: 'Запрос не выполнен',
  [Ml_Log_Status.Success]: 'Успешно',
};

export const LOG_STATUS: {
  [key in Ml_Log_Status]: {
    color: GradeColor['light'];
    backgroundColor: GradeColor['contrast'];
    title: string;
  };
} = {
  [Ml_Log_Status.Error]: {
    color: palette.orange.light,
    backgroundColor: palette.orange.contrast,
    title: LOG_STATUS_TITLE[Ml_Log_Status.Error],
  },
  [Ml_Log_Status.Initialized]: {
    color: palette.green.light,
    backgroundColor: palette.green.contrast,
    title: LOG_STATUS_TITLE[Ml_Log_Status.Initialized],
  },
  [Ml_Log_Status.InternalError]: {
    color: palette.red.light,
    backgroundColor: palette.red.contrast,
    title: LOG_STATUS_TITLE[Ml_Log_Status.InternalError],
  },
  [Ml_Log_Status.RequestFailed]: {
    color: palette.red.light,
    backgroundColor: palette.red.contrast,
    title: LOG_STATUS_TITLE[Ml_Log_Status.RequestFailed],
  },
  [Ml_Log_Status.Success]: {
    color: grey[400],
    backgroundColor: grey[700],
    title: LOG_STATUS_TITLE[Ml_Log_Status.Success],
  },
};

export const LOG_STATUS_OPTIONS: Array<{ id: Ml_Log_Status; displayName: string }> =
  generateOptions(LOG_STATUS_TITLE);
